<main role="main" class="flex flex-col items-center justify-center h-screen text-center">
  <h1 class="text-3xl font-bold" aria-label="Foutmelding: pagina niet gevonden">404</h1>
  <p class="mt-2 text-lg">Pagina niet gevonden</p>
  <p class="mt-2 text-gray-500">De pagina die je probeerd te bereiken bestaat niet (meer).</p>
</main>
